import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled, { css } from 'styled-components';
export const CommonTextInputStyles = css `
  ${fonts.gotham.regular};

  --bgColour: ${brand.global.white};
  --borderColour: ${brand.global.black};
  --borderRadius: 100px;
  --placeholderColour: ${brand.grey.grey35};
  --readOnlyColour: ${brand.grey.grey40};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: var(--bgColour);
  border: 2px solid var(--borderColour);
  border-radius: var(--borderRadius);
  color: var(--textColour);
  height: 52px;
  font-size: ${fluid(16, 16)};
  margin: 0;
  padding: 6px 24px;
  width: 100%;

  &:disabled {
    opacity: 0.5;
    color: var(--readOnlyColour);
    cursor: not-allowed;
  }

  &:read-only,
  &[readonly] {
    color: var(--readOnlyColour);
  }

  &::placeholder {
    color: var(--placeholderColour);
    opacity: 0.5;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
const Input = styled.input `
  ${CommonTextInputStyles};
`;
const TextboxStyles = {
    Input,
};
export default TextboxStyles;
